export const TESTIMONIALS_MAX_PERSPECTIVES = 5;
